import { useSelector } from 'react-redux';
import _ from 'lodash';

import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from '@mui/material';

import { darkTableTheme } from '../components/lib/legacy/table/dark.theme.base';
import { lightTableTheme } from '../components/lib/legacy/table/light.theme.base';

import type { RootStore } from '../types';
import type { WithChildrenProps } from '../types/components/common';

const themes = {
  dark: darkTableTheme,
  light: lightTableTheme,
};

export const TableThemeProvider = ({ children }: WithChildrenProps) => {
  const reduxThemeMode = useSelector(
    (state: RootStore) => state.uiSettings.theme
  );

  const theme = themes[reduxThemeMode];

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider
        theme={(outerTheme) => _.merge(Object.create(null), theme, outerTheme)}
      >
        {children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default TableThemeProvider;
